<template>
    <div class="Course">
        <div class="title">{{$t('text.course')}}
            <div class="back" @click="$router.go(-1)">
                <van-icon name="arrow-left" />
            </div>
        </div>
        <!-- <div class="tabs">
            <van-tabs v-model:active="activeBtn"  @change="onClickTab">
                <van-tab v-for="item in courseBtnList" :key="item.title" :title="item.title"></van-tab>
            </van-tabs>
        </div> -->
        <div class='historyList'>
            <div class="courseList">
                <div class="course" v-for="(e,i) in courseList" :key="i">
                    <div class="courseLeft">
                        <van-image  :src="$utils.setSourcePath(e.preview)">
                        </van-image>
                        
                    </div>
                    <div class="courseRight">
                        <div class="title ellipsis">{{ e.title }}</div>
                        <div class="tag">{{ e.typeName }}</div>
                        <div class="timeBtn">
                            <span>{{ e.length }}min</span>
                            <sd-button mini2 @click.native="toPage('/learn-detail',{id: e.id})">{{$t('text.learn')}}</sd-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "cases",
    components: {  },
    data() {
        return {
            checked: false,
            activeBtn: 'all',
            courseBtnList: [
                {
                    title: this.$t('text.all'),
                },
                {
                    title: this.$t('text.unlocked'),
                },
                {
                    title: this.$t('text.not_unlocked'),
                }
            ],
            courseList: [],
        }
    },

    computed: {
        
    },
    watch: {},

    mounted() {
        this.courseList = JSON.parse(localStorage.getItem('courseList'))
    },
    beforeDestroy() {
        localStorage.removeItem('courseList')
    },

    methods: {
        // onClickTab(name) {
        //     console.log(name);
        //     if (name === 0) {
        //         this.courseList = JSON.parse(localStorage.getItem('courseList'))
        //     } else if (name === 1) {
        //         this.courseList = JSON.parse(localStorage.getItem('courseList')).filter(item => item.isLocked === 1)
        //     } else if (name === 2) {
        //         this.courseList = JSON.parse(localStorage.getItem('courseList')).filter(item => item.isLocked === 2)
        //     }
        // },
        toPage(path, query) {
            this.$router.push({
                path, query
            })
        },
    },

    beforeDestroy() {
    }
}
</script>

<style lang="scss">
.Course {
    background: #F4F5F8;
    height: 100%;
    overflow: auto;
    font-size: 14px;
    font-weight: bold;
    .title{
        background-color: #fff;
        font-size: 16px;
        height: 50px;
        line-height: 50px;
        .back{
            position: absolute;
            top: 0;
            left: 0;
            margin-left: 10px;
        }
    }
    .tabs{
        width: 100%;
        height: 40px;
        font-size: 14px;
        &::-webkit-scrollbar {
          display: none;
        }
        .van-tabs__nav,.van-tabs__wrap{
            padding-bottom: 0;
            height: 40px;
            .van-tabs__line{
                width: 30%;
                bottom: 0;
            }
        }
        .van-tab--active{
            .van-tab__text{
                color: #000 !important;
            }
        }
        .van-tab__text{
            width: 100%;
            line-height: 40px;
            color: #636872;
            font-weight: bold;
            font-size: 14px;
        }
    }
    .historyList{
        width: 100%;
        overflow: auto;
        height: calc(100% - 50px);
        &::-webkit-scrollbar {
          display: none;
        }
        .courseList{
            margin: 10px;
            width: calc(100% - 20px);
            .name{
                font-size: 16px;
                text-align: left;
            }
            .course{
                box-sizing: border-box;
                width: 100%;
                display: flex;
                padding: 10px;
                border-radius: 5px;
                background: #fff;
                margin-top: 20px;
                .courseLeft{
                    .van-image{
                        width: 150px;
                        height: 100px;
                        span{
                            background: rgba(0,0,0,.4);
                            padding: 2px;
                            color: #fff;
                            border-radius: 4px;
                            position: absolute;
                            bottom: 0;
                            min-width: 40px;
                            left: 2px;
                            font-weight: normal;
                        }
                    }
                }
                .courseRight{
                    width: calc(100% - 150px);
                    .title{
                        text-align: left;
                        text-indent: 5px;
                    }
                    .tag{
                        font-weight: normal;
                        display: inline-block;
                        padding: 4px;
                        border-radius: 4px;
                        color: #636872;
                        background: #e6e7ea;
                        float: left;
                        margin-left: 10px;
                    }
                    .timeBtn{
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        padding: 10px;
                        box-sizing: border-box;
                        .main-block{
                            width: 80px;
                            height: 30px;
                        }
                    }
                }
            }

        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/school/course.vue